import BaseLogger from "../BaseLogger";
import LoggingSource from "../LoggingSource";
import logger from "./asoftLogger";

export default class JSLoggerWrapper extends BaseLogger {
  private _logger = logger;

  debug(message: string, loggingSource?: LoggingSource): void {
    if (loggingSource) this._logger.get(loggingSource).debug(message);
    else this._logger.debug(message);
  }
  info(message: string, loggingSource?: LoggingSource): void {
    if (loggingSource) this._logger.get(loggingSource).info(message);
    else this._logger.info(message);
  }
  warning(message: string, loggingSource?: LoggingSource): void {
    if (loggingSource) this._logger.get(loggingSource).warn(message);
    else this._logger.warn(message);
  }
  error(message: string, loggingSource?: LoggingSource): void {
    if (loggingSource) this._logger.get(loggingSource).error(message);
    else this._logger.error(message);
  }
  critical(message: string, loggingSource?: LoggingSource): void {
    throw new Error("Method not implemented.");
  }

  timeStart(label: string, loggingSource?: LoggingSource): void {
    if (loggingSource) this._logger.get(loggingSource).time(label);
    else this._logger.time(label);
  }

  timeEnd(label: string, loggingSource?: LoggingSource): void {
    if (loggingSource) this._logger.get(loggingSource).timeEnd(label);
    else this._logger.timeEnd(label);
  }
}
